(function () {
  var pdp = document.querySelector('[data-vm-product]');
  var form = pdp && pdp.querySelector('form.vm-offerbox');
  var offers = form && form.querySelector('.vm-offers');
  var cfgEl = document.querySelector('[data-vlt-config]');
  if (!offers || !cfgEl || offers.getAttribute('data-vlt')) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  offers.setAttribute('data-vlt', '1');
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* 1) offer cards + heading */
  offers.innerHTML = document.querySelector('template[data-vlt-cards]').innerHTML;
  offers.classList.add('vlt-offers');
  offers.setAttribute('aria-label', 'Choose your gift set');
  var labH = offers.previousElementSibling;
  var headHtml = document.querySelector('template[data-vlt-head]').innerHTML;
  if (labH && labH.classList.contains('vm-lab-h')) labH.outerHTML = headHtml; else offers.insertAdjacentHTML('beforebegin', headHtml);

  var nudge = document.createElement('button');
  nudge.type = 'button';
  nudge.className = 'vlt-nudge';
  offers.parentNode.insertBefore(nudge, offers.nextSibling);

  /* 2) letters: "Gift 1-3" labels, heading, per-person set summary */
  var slotsWrap = form.querySelector('[data-vm-slots]');
  var slotEls = slotsWrap ? Array.prototype.slice.call(slotsWrap.querySelectorAll('.vm-slot')) : [];
  form.classList.add('vlt-on');
  slotEls.forEach(function (s, i) {
    var gl = document.createElement('span');
    gl.className = 'vlt-gl';
    gl.textContent = cfg.gift + ' ' + (i + 1);
    s.insertBefore(gl, s.firstChild);
  });
  var who = document.createElement('div');
  who.className = 'vlt-who';
  who.innerHTML = '<b>' + esc(cfg.who) + '</b><span data-vlt-hint></span>';
  if (slotsWrap) slotsWrap.parentNode.insertBefore(who, slotsWrap);
  var sets = document.createElement('div');
  sets.className = 'vlt-sets';
  if (slotsWrap) slotsWrap.parentNode.insertBefore(sets, slotsWrap.nextSibling);

  var custom = false, over = {};
  function tier() { var r = form.querySelector('input[name="vm_offer"]:checked'); return r ? +r.getAttribute('data-tier') : 1; }
  function letterOf(i) {
    var sel = slotEls[i] && slotEls[i].querySelector('select');
    if (!sel || !sel.value) return '';
    return sel.options[sel.selectedIndex].text.trim().charAt(0).toUpperCase();
  }
  function pieceLetter(i, key) {
    var L = letterOf(i);
    if (custom && over[i + '|' + key]) return over[i + '|' + key];
    return L;
  }
  function letterOpts(key, cur) {
    return Object.keys(cfg[key]).sort().map(function (L) { return '<option value="' + L + '"' + (L === cur ? ' selected' : '') + '>' + L + '</option>'; }).join('');
  }
  function item(key, i, name) {
    var L = pieceLetter(i, key);
    var imgs = key === 'anklet' ? cfg.aimg : cfg.rimg;
    var img = imgs[L || 'A'];
    var pic = img ? '<img src="' + esc(img) + '" alt="" width="36" height="36" loading="lazy">' : '';
    if (custom) {
      return '<label class="vlt-it">' + pic + '<select data-vlt-over="' + i + '|' + key + '" aria-label="' + name + ' letter for ' + cfg.gift + ' ' + (i + 1) + '"><option value="">' + name + ' · same</option>' + letterOpts(key, over[i + '|' + key] || '') + '</select></label>';
    }
    return '<span class="vlt-it">' + pic + '<span>' + name + (L ? ' · ' + L : '') + '</span></span>';
  }
  function render() {
    var t = tier();
    var r = form.querySelector('input[name="vm_offer"]:checked');
    var hint = who.querySelector('[data-vlt-hint]');
    if (hint) hint.textContent = cfg.hints[t - 1] || '';
    var nt = r ? r.getAttribute('data-nudge') : '';
    var ut = r ? r.getAttribute('data-up-title') : '';
    var ux = r ? r.getAttribute('data-up-text') : '';
    var ui = r ? r.getAttribute('data-up-img') : '';
    nudge.classList.toggle('is-done', t === 3);
    nudge.setAttribute('data-go', t < 3 ? String(t + 1) : '');
    if (t < 3 && ut) {
      nudge.hidden = false;
      nudge.innerHTML = (ui ? '<span class="vlt-up-im"><img src="' + esc(ui) + '" alt="" width="44" height="44"></span>' : '') +
        '<span class="vlt-up-tx"><b>' + esc(ut) + '</b><small>' + esc(ux) + '</small></span><span class="vlt-up-btn">' + esc(cfg.upBtn || 'UPGRADE') + '</span>';
    } else if (nt) {
      nudge.hidden = false;
      nudge.innerHTML = '<span class="vlt-up-ok">✓</span><span class="vlt-up-done">' + esc(nt) + '</span>';
    } else { nudge.hidden = true; nudge.innerHTML = ''; }
    if (t < 2) { sets.hidden = true; sets.innerHTML = ''; }
    else {
      sets.hidden = false;
      var rows = slotEls.map(function (s, i) {
        var L = letterOf(i);
        return '<div class="vlt-row' + (L ? '' : ' is-empty') + '"><div class="vlt-p"><span>' + esc(cfg.gift) + ' ' + (i + 1) + '</span>' + (L ? '<b>' + L + '</b>' : '<em>' + esc(cfg.pick || 'Choose a letter above') + '</em>') + '</div><div class="vlt-items">' +
          item('anklet', i, 'Anklet') + (t === 3 ? item('ring', i, 'Ring') : '') + '</div></div>';
      }).join('');
      sets.innerHTML = (cfg.setsHead ? '<div class="vlt-sh">' + esc(cfg.setsHead) + '</div>' : '') + rows + '<label class="vlt-cust"><input type="checkbox" data-vlt-custom' + (custom ? ' checked' : '') + '> ' + esc(cfg.custom) + '</label>';
    }
    var btn = r ? r.getAttribute('data-btn') : '';
    var atc = form.querySelector('.vm-atc');
    var sticky = pdp.querySelector('.vm-stickybar');
    if (btn && atc && !atc.disabled) atc.textContent = btn;
    if (btn && sticky && !sticky.disabled) sticky.textContent = btn;
    var so = pdp.querySelector('[data-vm-sbar-offer]');
    if (so && r) so.textContent = r.getAttribute('data-short');
  }
  nudge.addEventListener('click', function () {
    var go = nudge.getAttribute('data-go');
    var r = go && form.querySelector('input[name="vm_offer"][data-tier="' + go + '"]');
    if (!r) return;
    r.checked = true;
    r.dispatchEvent(new Event('change', { bubbles: true }));
  });
  form.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute && t.hasAttribute('data-vlt-custom')) { custom = t.checked; }
    else if (t.hasAttribute && t.hasAttribute('data-vlt-over')) { over[t.getAttribute('data-vlt-over')] = t.value; }
    setTimeout(render, 0);
  });

  /* 3) anklets + rings go in with the necklaces, grouped so the cart shows necklaces, anklets, rings */
  window.vmExtraItems = function (f) {
    if (f !== form) return [];
    var t = tier(), out = [], label = t === 3 ? 'Complete Set' : 'Gift Set';
    if (t < 2) return out;
    ['anklet', 'ring'].forEach(function (key) {
      if (key === 'ring' && t < 3) return;
      slotEls.forEach(function (s, i) {
        var id = cfg[key][pieceLetter(i, key)];
        if (id) out.push({ id: id, quantity: 1, properties: { '_Velmora set': label } });
      });
    });
    return out;
  };
  window.vmExtraAdded = function () {};

  /* 4) photo viewer: white sheet from the bottom, bars for each photo, swipe; stays on the page */
  form.addEventListener('click', function (e) {
    var z = e.target.closest('[data-vlt-zoom]');
    if (!z) return;
    e.preventDefault();
    e.stopPropagation();
    var pics = cfg.gal[z.getAttribute('data-vlt-zoom')] || [];
    if (!pics.length) return;
    var cur = 0, sx = null, sy = null;
    var lb = document.createElement('div');
    lb.className = 'vlt-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<div class="vlt-sheet"><button type="button" class="vlt-x" aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="vlt-stage"><img alt=""></div>' +
      (pics.length > 1 ? '<div class="vlt-dash">' + pics.map(function (p, i) { return '<button type="button" aria-label="Photo ' + (i + 1) + '"></button>'; }).join('') + '</div>' : '') + '</div>';
    document.body.appendChild(lb);
    document.documentElement.classList.add('vlt-lock');
    var img = lb.querySelector('.vlt-stage img');
    pics.forEach(function (p) { var im = new Image(); im.src = p; });
    function show(n) {
      cur = (n + pics.length) % pics.length;
      img.src = pics[cur];
      lb.querySelectorAll('.vlt-dash button').forEach(function (d, i) { d.classList.toggle('on', i === cur); });
    }
    function close() {
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('vlt-lock');
      document.removeEventListener('keydown', key);
      setTimeout(function () { lb.remove(); }, 250);
    }
    function key(ev) { if (ev.key === 'Escape') close(); else if (ev.key === 'ArrowLeft') show(cur - 1); else if (ev.key === 'ArrowRight') show(cur + 1); }
    lb.addEventListener('click', function (ev) {
      ev.stopPropagation();
      var d = ev.target.closest('.vlt-dash button');
      if (d) { show(Array.prototype.indexOf.call(d.parentNode.children, d)); return; }
      if (ev.target.closest('.vlt-x') || ev.target === lb) close();
    });
    lb.addEventListener('touchstart', function (ev) { sx = ev.touches[0].clientX; sy = ev.touches[0].clientY; }, { passive: true });
    lb.addEventListener('touchend', function (ev) {
      if (sx === null) return;
      var dx = ev.changedTouches[0].clientX - sx, dy = ev.changedTouches[0].clientY - sy;
      sx = sy = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? cur + 1 : cur - 1);
      else if (dy > 90) close();
    }, { passive: true });
    document.addEventListener('keydown', key);
    show(0);
    requestAnimationFrame(function () { lb.classList.add('is-open'); });
  }, true);

  render();
  document.addEventListener('DOMContentLoaded', function () { setTimeout(render, 0); });
})();